/**
 * Cláusulas especiais e observações gerais padrão do RD Equipamentos (ramo
 * 0171) — transcritas VERBATIM de `STANDARD_CLAUSES`/`STANDARD_NOTES` em
 * `alba-portal-seguros-demo/modules/pdf_policy.py` (fonte: documento do
 * Ramo 0171, seções "CLÁUSULAS ESPECIAIS" e "OBSERVAÇÕES"). Exibidas no
 * Accordion "Cláusulas e observações gerais" do breakdown de cotação
 * (`QuoteBreakdown`, Step 5 — Cotação / Step 6 — Emissão).
 */
export const STANDARD_CLAUSES: readonly string[] = [
  'Equipamentos operados pelo segurado/funcionários — todos os operadores devem ser licenciados ou, na ausência de exigência legal, ter concluído treinamento técnico e ter experiência prática nos maquinários.',
  'Garantia geral de manutenção e manutenção preventiva — manutenção geral anual por item, conforme o cronograma do fabricante (no máximo a cada 12 meses), com registro completo de reparos e trocas de óleo.',
  'Medidas de segurança (roubo/furto) — fora do horário de expediente os equipamentos devem ficar em locais fechados e cercados; em vias públicas ou locais abertos, sob vigilância permanente. Equipamento que pernoitar em via pública fica excluído da cobertura.',
];

/**
 * Cláusulas obrigatórias quando a proposta está marcada como equipamento
 * locado/arrendado/cedido a terceiros (PO 2026-07-20). Espelham VERBATIM as
 * `LEASED_CLAUSES` de `alba-portal-seguros-demo/modules/pdf_policy.py` —
 * exibidas junto das cláusulas especiais quando
 * `proposal.leasedToThirdParties` é true (breakdown E apólice).
 */
export const LEASED_TO_THIRD_PARTIES_CLAUSES: readonly string[] = [
  'Cláusula Particular — Equipamento locado, arrendado ou cedido a terceiros: treinamento de operadores obrigatório para todos os usuários do equipamento.',
  'Cláusula Particular — Equipamento locado, arrendado ou cedido a terceiros: programa de gerenciamento de risco obrigatório durante toda a vigência.',
];

/**
 * Observações gerais do produto — alíneas a–n da especificação do PO
 * (2026-09-08), transcritas VERBATIM de `STANDARD_NOTES`/`QUOTE_ONLY_NOTES`
 * em `alba-portal-seguros-demo/modules/pdf_policy.py`. As duas listas são
 * mantidas em espelho à mão: mudou lá, muda aqui.
 */
const A_CONDICOES_GERAIS =
  'Aplicam-se a este seguro as Condições Gerais do Alba Equipamentos — Processo SUSEP 15414.634999/2024-86 e poderão ser consultadas no endereço eletrônico www.susep.gov.br.';
const B_PAGAMENTO = 'Formas de Pagamento: parcelamento em até 6× sem juros.';
const C_REINTEGRACAO =
  'Informamos que o nosso produto não contempla reintegração automática.';
const D_BASE_DA_COTACAO =
  'As cotações são executadas com base nas informações apresentadas no pedido de cotação enviado pelo corretor. Quaisquer divergências nessas informações podem gerar modificações na proposta inicialmente apresentada.';
const E_VALIDADE =
  'Esta cotação tem validade por 15 dias e não pressupõe a aceitação do risco pela seguradora.';
const F_RETROATIVIDADE = 'Não é permitida retroatividade de vigência.';
const G_INSPECAO = 'Sujeito a análise da inspeção de risco.';
const H_LMI =
  'A definição do(s) limite(s) máximo(s) de indenização são de inteira responsabilidade do Segurado, ficando a Seguradora isenta de qualquer responsabilidade que possa advir de avaliações incorretas.';
const I_SEM_AGRO =
  'Não haverá cobertura para equipamentos relacionados à atividade agrícola, pecuária ou florestal e para drones.';
const J_SEM_AGUA =
  'Esta operação não concede amparo para operações sobre água, nem subterrânea e drones.';
const K_CONSULTA_CADASTRAL =
  'O segurado poderá consultar a situação cadastral do corretor de seguros e da sociedade seguradora no sítio eletrônico www.susep.gov.br.';
const L_COBERTURA_BASICA =
  'Cobertura básica — Incêndio; Roubo e/ou Furto Qualificado; Transporte por meios adequados; Danos de causas externas.';
const M_IDENTIFICACAO =
  'Para a cobertura do seguro deverá constar na apólice o nome do equipamento, marca, modelo, número de série ou chassi, ano de fabricação e valor.';
const N_AVISO_SINISTRO =
  'AVISO DE SINISTRO: Imediatamente após a ocorrência, deverá ser enviado o aviso com a descrição da ocorrência com respectiva data e hora, estimativa de prejuízos, medidas de contenção de prejuízos, n.º da apólice e identificação do local de risco constante na apólice, nome da pessoa de contato para agendamento de vistoria com respectivos dados de telefone e e-mail para área de sinistro da Cia. de Seguros Aliança da Bahia através da chave atendimento@alba.com.br';

/** Válidas em qualquer contexto (cotação E apólice emitida). */
export const STANDARD_NOTES: readonly string[] = [
  A_CONDICOES_GERAIS,
  'Forma de contratação da apólice: Risco Relativo.',
  C_REINTEGRACAO,
  F_RETROATIVIDADE,
  G_INSPECAO,
  H_LMI,
  I_SEM_AGRO,
  J_SEM_AGUA,
  K_CONSULTA_CADASTRAL,
  L_COBERTURA_BASICA,
  M_IDENTIFICACAO,
  N_AVISO_SINISTRO,
];

/**
 * Observações que só fazem sentido enquanto COTAÇÃO — não devem sair na
 * apólice emitida, que é documento contratual — a apólice é montada pela
 * Folheteria, no motor, e não reaproveita estas listas.
 */
export const QUOTE_ONLY_NOTES: readonly string[] = [
  B_PAGAMENTO,
  D_BASE_DA_COTACAO,
  E_VALIDADE,
];

/**
 * Lista completa exibida no breakdown de cotação (Steps Cotação/Emissão),
 * NA ORDEM da especificação (a–n) — e não a concatenação das duas listas
 * acima, que jogaria as alíneas só-cotação para o fim.
 */
export const QUOTE_NOTES: readonly string[] = [
  A_CONDICOES_GERAIS,
  B_PAGAMENTO,
  C_REINTEGRACAO,
  D_BASE_DA_COTACAO,
  E_VALIDADE,
  F_RETROATIVIDADE,
  G_INSPECAO,
  H_LMI,
  I_SEM_AGRO,
  J_SEM_AGUA,
  K_CONSULTA_CADASTRAL,
  L_COBERTURA_BASICA,
  M_IDENTIFICACAO,
  N_AVISO_SINISTRO,
];
